

// Sidebar start
$(document).ready(function () {

  // Custom Select
    $( ".customSelect" ).selectmenu();

  // Date Picker
  $( ".customDatepicker" ).datepicker({
    showOn: "button",
    //buttonImage: "../images/date.png",
    buttonImageOnly: false,
    buttonText: ""
  });

  window.initializeDatepickers = function() {
    if (window.$ && window.$.fn.datepicker) {
      $(".customDatepicker:not(.hasDatepicker)").datepicker({
        showOn: "button",
        buttonImageOnly: false,
        buttonText: ""
      });
    }
  };


  $('.menu-toggle').click(function () {
    $('nav').toggleClass('active');
    $('.menu-toggle').toggleClass('active');
    $('body').toggleClass('navOpen');
  });

  var parent = document.querySelector(".lsForm");

  // password show/hide helper function
  function showHide(input, showText) {
    if (input.getAttribute("type") === "password") {
      input.setAttribute("type", "text");
      showText.classList = "show";
    } else {
      input.setAttribute("type", "password");
      showText.classList = "hide";
    }
  }

  // event delegation on event target match
  if(parent) {
    parent.addEventListener("click", event => {
      if (event.target.matches("button")) {
        var spanElm = event.target;
        var inputElm = spanElm.previousElementSibling;
        showHide(inputElm, spanElm);
      }
    })
  }

  "use strict";
  var offSetTop = 100;
  var $scrollToTopButton = $('.scrollToTop');
  //Check to see if the window is top if not then display button
  $(window).scroll(function () {
    if ($(this).scrollTop() > offSetTop) {
      $scrollToTopButton.fadeIn();
    } else {
      $scrollToTopButton.fadeOut();
    }
  });
  //Click event to scroll to top
  $scrollToTopButton.click(function () {
    $('html, body').animate({ scrollTop: 0 }, 300);
    return false;
  });

// ** //


$(".nav-link.dropdown-toggle").click(function(){
  $(".navbar-collapse").toggleClass("scrollEnable");
  $(".navbar").toggleClass("ddOpen");
});

// ** //


})

window.onscroll = function () { myFunction() };

var header = document.getElementById("myHeader");
var mainWrap = document.getElementById("mainWrap");
var sticky = header ? header.offsetTop : 0;
function myFunction() {
  if (header && mainWrap) {
    if (window.pageYOffset > sticky) {
      header.classList.add("sticky_header");
      mainWrap.classList.add("sticky_header");
    } else {
      header.classList.remove("sticky_header");
      mainWrap.classList.remove("sticky_header");
    }
  }
}
// Sticky Header end

// Army //
// const input = document.getElementById("photo-upload");
// const preview = document.getElementById("preview");

// input.addEventListener("change", () => {
//   const file = input.files[0];
//   if (file) {
//     const reader = new FileReader();
//     reader.onload = e => {
//       preview.src = e.target.result;
//       preview.style.display = "block";
//       preview.parentElement.classList.add("hasImg");
//     };
//     reader.readAsDataURL(file);
//   }
// });

// signature script
// var canvas = document.getElementById("signature");
// var signaturePad = new SignaturePad(canvas);

// $('#clear-signature').on('click', function(){
//   signaturePad.clear();
// });

